import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {FicheIntervention} from 'app/models/ficheIntervention.model';
import {Router} from '@angular/router';
import {DossierIntervention} from 'app/models/dossier_intervention.model';
import {DossierInterventionService} from 'app/services/dossier_intervention.service';
import {FormulaireAutorisationInterventionService} from 'app/services/formulaire-autorisation-intervention.service';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {FormulaireAutorisationIntervention} from 'app/models/formulaireAutorisationIntervention.model';
import {tap, concatMap, takeUntil, catchError} from 'rxjs/operators';
import {fromEvent, throwError} from 'rxjs';
import {environment} from 'environments/environment';
import {FuseConfirmationService} from '@fuse/services/confirmation';
import {ToastrService} from 'ngx-toastr';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-formulaire-autorisation-intervention',
    templateUrl: './formulaire-autorisation-intervention.component.html',
    styleUrls: ['./formulaire-autorisation-intervention.component.scss']
})
export class FormulaireAutorisationInterventionComponent implements AfterViewInit, OnInit {
    @Input() dossierIntervention: DossierIntervention;
    @Output() submitEvent = new EventEmitter();
    @Output() valueChangedEvent = new EventEmitter();
    @ViewChild('myCanvas', {static: false}) myCanvas: ElementRef;

    formulaireAutorisationInterventionForm: FormGroup;
    STORAGE_URL = environment.STORAGE_IMAGE;
    private API_URL= environment.API_URL;

    fermer: boolean = false;
    success: boolean = false;
    error: boolean = false;

    blankCanvas;
    context;
    formulaireIntervention: FormulaireAutorisationIntervention;


    get possedeSignature(): boolean {
        const canvas = <HTMLCanvasElement>document.getElementById('myCanvas');
        return canvas == null || (canvas.toDataURL() !== this.blankCanvas.toDataURL());
    }

    constructor(
        private dossierInterventionService: DossierInterventionService,
        private formulaireAutorisationInterventionService: FormulaireAutorisationInterventionService,
        private fuseConfirmationService: FuseConfirmationService,
        private router: Router, private toastr: ToastrService,
        private http: HttpClient
    ) {}

    ngOnInit(): void {
        this.formulaireAutorisationInterventionForm = new FormGroup({
            dossier_intervention_id: new FormControl(this.dossierIntervention.id),
            nom_assure: new FormControl(null),
            adresse_domicile: new FormControl(null),
            adresse_propriete_endommagee: new FormControl(null),
            compagnie_assurance: new FormControl(null),
            no_police_assurance: new FormControl(null),
            no_dossier_intervention: new FormControl(null),
            nom_expert_sinistre: new FormControl(null),
            nom_compagnie_expertise: new FormControl(null),
            signature_client: new FormControl(null),
            courriel_client: new FormControl(null),
            commentaire_signature: new FormControl(null),
            fermer: new FormControl(false),
            pdf_signe: new FormControl(false),
        });
        this.blankCanvas = document.createElement('canvas');
        this.blankCanvas.width = 664;
        this.blankCanvas.height = 314;

        this.getDossierIntervention();
    }

    ngAfterViewInit(): void {
        if (this.myCanvas != null) {
            const canvasEl: HTMLCanvasElement = this.myCanvas.nativeElement;
            this.context = canvasEl.getContext('2d');

            //Signature avec une souris
            const mouseDown$ = fromEvent(this.myCanvas.nativeElement, 'mousedown');
            const mouseMove$ = fromEvent(this.myCanvas.nativeElement, 'mousemove');
            const mouseUp$ = fromEvent(this.myCanvas.nativeElement, 'mouseup');

            mouseDown$.pipe(concatMap(down => mouseMove$.pipe(takeUntil(mouseUp$))));

            const mouseDraw$ = mouseDown$.pipe(
                tap((e: MouseEvent) => {
                    this.context.moveTo(e.offsetX, e.offsetY);
                }),
                concatMap(() => mouseMove$.pipe(takeUntil(mouseUp$)))
            );
            mouseDraw$.subscribe((e: MouseEvent) => {
                this.draw(e.offsetX, e.offsetY);
            });

            //signature sur mobile
            const touchstart$ = fromEvent(this.myCanvas.nativeElement, 'touchstart');
            const touchMove$ = fromEvent(this.myCanvas.nativeElement, 'touchmove');
            const touchend$ = fromEvent(this.myCanvas.nativeElement, 'touchend');

            touchstart$.pipe(concatMap(down => touchMove$.pipe(takeUntil(touchend$))));

            const touchDraw$ = touchstart$.pipe(
                tap((e: TouchEvent) => {
                    const touch = e.touches[0];

                    // element est le canvas
                    const targetElement = touch.target as HTMLElement;

                    // Get the bounding rectangle of the target element
                    const rect = targetElement.getBoundingClientRect();

                    // Calculer le offset
                    const offsetX = touch.clientX - rect.left;
                    const offsetY = touch.clientY - rect.top;

                    this.context.moveTo(offsetX, offsetY);
                }),
                concatMap(() => touchMove$.pipe(takeUntil(touchend$)))
            );
            touchDraw$.subscribe((e: TouchEvent) => {
                e.preventDefault();
                const touch = e.touches[0];

                // element est le canvas
                const targetElement = touch.target as HTMLElement;

                // Get the bounding rectangle of the target element
                const rect = targetElement.getBoundingClientRect();

                // Calculer le offset
                const offsetX = touch.clientX - rect.left;
                const offsetY = touch.clientY - rect.top;
                this.draw(offsetX, offsetY);
            });
        }
    }

    getDossierIntervention() {
        this.dossierInterventionService.getFormaulaireAutorisationIntervention(this.dossierIntervention.id).subscribe((formulaireIntervention) => {
            this.formulaireIntervention = formulaireIntervention;
            this.formulaireAutorisationInterventionForm = new FormGroup({
                dossier_intervention_id: new FormControl(this.dossierIntervention.id),
                nom_assure: new FormControl(this.dossierIntervention.nom_assure),
                adresse_domicile: new FormControl(formulaireIntervention?.adresse_domicile),
                adresse_propriete_endommagee: new FormControl(this.dossierIntervention.adresse_propriete_endommagee),
                compagnie_assurance: new FormControl(this.dossierIntervention.compagnie_assurance),
                no_police_assurance: new FormControl(formulaireIntervention?.no_police_assurance),
                no_dossier_intervention: new FormControl(formulaireIntervention != null ? formulaireIntervention.no_dossier_intervention : this.dossierIntervention.no_dossier),
                nom_expert_sinistre: new FormControl(formulaireIntervention?.nom_expert_sinistre),
                nom_compagnie_expertise: new FormControl(formulaireIntervention?.nom_compagnie_expertise),
                signature_client: new FormControl(formulaireIntervention?.signature_client),
                courriel_client: new FormControl(formulaireIntervention?.courriel_client),
                commentaire_signature: new FormControl(formulaireIntervention?.commentaire_signature),
                fermer: new FormControl(formulaireIntervention != null ? formulaireIntervention.fermer : false),
                nom_pdf_signe: new FormControl(formulaireIntervention?.nom_pdf_signe),
                pdf_signe: new FormControl(formulaireIntervention?.pdf_signe),
            });

            this.formulaireAutorisationInterventionForm.valueChanges.subscribe(() => {
                this.valueChangedEvent.emit(true);
            });

            if (formulaireIntervention != null && formulaireIntervention.fermer == true) {
                this.fermer = true;
            } else {
                this.fermer = false;
            }
        });
    }

    callOnFormSubmit() {
        this.onFormSubmit(true).subscribe((result) => {
        });
    }

    onFormSubmit(redirect: boolean): Observable<string> {
        return new Observable<string>((observer) => {
            this.error = false;
            this.success = false;
            this.formulaireAutorisationInterventionForm.markAllAsTouched();
            if (this.formulaireAutorisationInterventionForm.valid) {
                //valider s'il y a une signature
                const canvas = <HTMLCanvasElement>document.getElementById('myCanvas');
                if (canvas != null) {
                    if (this.possedeSignature) {
                        const img = canvas.toDataURL('image/png');
                        this.formulaireAutorisationInterventionForm.patchValue({
                            signature_client: img
                        });
                    }
                }

                const activeButton = document.activeElement.id; // document.activeElement?.id
                let fermer = false;
                if (activeButton == 'fermer') {
                    fermer = true;
                }
                this.formulaireAutorisationInterventionForm.patchValue({
                    fermer: fermer
                });

                const formulaireAutorisationIntervention = new FormulaireAutorisationIntervention(this.formulaireAutorisationInterventionForm.value);
                if (this.formulaireIntervention != null) {
                    this.formulaireAutorisationInterventionService.update(formulaireAutorisationIntervention, this.formulaireIntervention.id).subscribe(
                        (response) => {
                            if (redirect) {
                                this.success = true;
                                this.valueChangedEvent.emit(false);
                                if (fermer == true) {
                                    this.router.navigate(['/dossiers-interventions'], {queryParams: {idDossierIntervention: this.dossierIntervention.id}});
                                }
                            }
                            observer.next('Observable emitted!');
                            observer.complete();
                        }, (error) => {
                            this.error = true;
                            this.showErrors(error);
                        }
                    );
                } else {
                    this.formulaireAutorisationInterventionService.store(formulaireAutorisationIntervention).subscribe(
                        (response) => {
                            if (redirect) {
                                this.success = true;
                                this.valueChangedEvent.emit(false);
                                if (fermer == true) {
                                    this.router.navigate(['/dossiers-interventions'], {queryParams: {idDossierIntervention: this.dossierIntervention.id}});
                                }
                            }
                            this.formulaireIntervention = response;
                            observer.next('Observable emitted!');
                            observer.complete();
                        }, (error) => {
                            this.error = true;
                            this.showErrors(error);
                        }
                    );
                }
            }
        });
    }

    retourDossierIntervention() {
        this.router.navigate(['/dossiers-interventions', this.dossierIntervention.id], {queryParams: {idDossierIntervention: this.dossierIntervention.id}});
    }

    draw(offsetX, offsetY) {
        this.context.lineTo(offsetX, offsetY);
        this.context.stroke();
    }

    refreshCanvas() {
        this.context.reset();
    }

    envoyerFormulaire() {
        const confirmation = this.fuseConfirmationService.open({
            title: 'Envoyer le formulaire d\'autorisation d\'intervention',
            message: 'Êtes-vous certain de vouloir envoyer le formulaire d\'autorisation d\'intervention?',
            icon: {
                'color': 'primary'
            },
            actions: {
                confirm: {
                    label: 'Envoyer',
                    color: 'primary'
                }
            }
        });

        confirmation.afterClosed().subscribe((result) => {
            if (result === 'confirmed') {
                this.onFormSubmit(false).subscribe(() => {
                    this.formulaireAutorisationInterventionService.envoyerFormulaire(this.formulaireIntervention.id).subscribe(() => {
                        this.toastr.success('Le formulaire d\'autorisation d\'intervention a été envoyé.');
                    });
                });
            }
        });
    }

    onFileSelected(input) {
        if (input.target.files && input.target.files[0]) {
            const reader = new FileReader();

            reader.onload = (e: any) => {
                this.formulaireAutorisationInterventionForm.patchValue({
                    nom_pdf_signe: input.target.files[0].name,
                    pdf_signe: e.target.result
                });
            };

            reader.readAsDataURL(input.target.files[0]);
        }
    }

    get nomPdfSigne(): string {
        return this.formulaireAutorisationInterventionForm.value.nom_pdf_signe != null ? this.formulaireAutorisationInterventionForm.value.nom_pdf_signe : 'Aucun fichier choisi';
    }

    get possedeCourriel(): boolean {
        const verifCourriel = String(this.formulaireAutorisationInterventionForm.get('courriel_client').value)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
        return verifCourriel == null ? false : true;
    }

    ajouterPdf() {
        const element: HTMLElement = document.getElementById('formulaireAutorisationInterventionSigne') as HTMLElement;
        // add this condition will solve issue
        if (element) {
            element.click();
        }
    }

    showErrors(error: any) {
        //Gestion des erreurs laravel
        if (error instanceof HttpErrorResponse) {
            for (const key in error.error.errors) {
                //Todo
            }
        } else {
            error.forEach((element) => {
                //this.toastr.error(element);
            });
        }
    }

    download() {
        this.http.get<any>(this.API_URL + 'formulaires-autorisations-interventions/'+ this.formulaireIntervention.id +'/pdf', {
            responseType: 'blob' as 'json'
        }).pipe(
            catchError(err => throwError(err))
        ).subscribe((blob)=> {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = (new Date()).toISOString() + '.pdf';
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
        });
    }

    openAsPdf() {
        this.http.get<any>(this.API_URL + 'formulaires-autorisations-interventions/'+ this.formulaireIntervention.id +'/pdf', {
            responseType: 'blob' as 'json'
        }).pipe(
            catchError(err => throwError(err))
        ).subscribe((blob)=> {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
        });
    }
}
